module.exports = __webpack_public_path__ + "static/media/wheel-tuluu.98746cd0.png";